export default {
  title: 'Alătură-te {{name}}!',
  default_program_name: 'Club de recompense',
  benefits: {
    earn_points: 'Câștigă puncte la fiecare comandă',
    get_deals: 'Primește reduceri exclusive',
    redeem_points: 'Schimbă punctele pentru mâncare gratuită',
  },
  terms: 'Prin înregistrare, vei primi oferte prin email și SMS de la&nbsp;',
  buttons: {
    log_in: 'Conectare',
    sign_up: 'Înregistrare',
  },
  labels: {
    already_have_account: 'Ai deja un cont?',
  },
  signup_note:
    'Prin înregistrare, vei primi oferte prin email și SMS de la <0>restaurantul</0> nostru și <1>FoodAmigos</1>, partenerul nostru tehnologic. Ești de acord cu <2>Termenii Platformei</2> și <3>Politica de confidențialitate</3>.',
};
